export const LoadingStore = {
    state: ({
        loading: false
    }),
    mutations: {
        setLoading : (state, value) => {
            state.loading = value
        }
    },
    getters: {
        getLoading: (state) => state.loading
    }
}
